const theme = {
	colors: {
		blue: "#3e8eef",
		violet: "#63267B",
		lightViolet: "#42526E",
		white: "#ffffff",
		black: "#000000",
		accordionGreen: "#00875A",
		textBlack: "#212121",
		red: "#DE350B",
		lightBlue: "#6554C0"
	},
	typography: {
		default: "16px",
		large: "20px",
		family: `Arial, Helvetica, sans-serif`
	},
	dropdownStyle: {
		backgroundColor: "#FAFBFC",
		boxShadow: "none"
	}
};

// Export
export default theme;
